import * as React from 'react'
import { translate } from 'react-translate'

class FeesButtonGroup extends React.Component<any, any> {
  render() {
    let t = this.props.t

    return (
      <div style={{ marginTop: '-5px' }}>
        <button className='button' style={
          { width: 'calc(50% - 3px)', margin: '0 3px 0 0px' }} onClick={() => {
            {/*this.updateData(id, accountId, marketplaceId, feeGroup[0].childAccountType)*/ }
            this.props.handleUpdateButton()
          }}> {t('UPDATE_FEES_BTN')} </button>
        <button className='button' style={
          { width: 'calc(50% - 3px)', margin: '0 0px 0 3px' }} onClick={() => {
            // will call getData method
            this.props.handleCancelButton()
          }}> {t('CANCEL_FEES_BTN')} </button>

        {!this.props.isUsingDefaultFees && this.props.feeView === 'account' ? (
          <button
            className='button'
            style={{ width: 'calc(100%)', marginTop: '10px' }}
            onClick={this.props.handleResetButton}> {t('RESET_FEES_BTN')} </button>
        ) : null}
      </div>)
  }
}
export default translate('FeesButtonGroup')(FeesButtonGroup)



// WEBPACK FOOTER //
// ./react/components/presentations/FeesButtonGroup.tsx